module.exports = __webpack_public_path__ + "img/project18_4.png.0af0ccb0.webp";